/**
 * INR formatting + amount in words (Indian numbering: Lakh, Crore).
 */

const ONES = [
  "",
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
  "Ten",
  "Eleven",
  "Twelve",
  "Thirteen",
  "Fourteen",
  "Fifteen",
  "Sixteen",
  "Seventeen",
  "Eighteen",
  "Nineteen",
];

const TENS = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

function twoDigits(n) {
  if (n < 20) return ONES[n];
  const t = Math.floor(n / 10);
  const o = n % 10;
  return o ? `${TENS[t]} ${ONES[o]}` : TENS[t];
}

export function amountInWordsInr(n) {
  let v = Math.round(Math.abs(Number(n)));
  if (!Number.isFinite(v)) return "";
  if (v === 0) return "Zero";

  const parts = [];
  const crore = Math.floor(v / 10000000);
  v %= 10000000;
  const lakh = Math.floor(v / 100000);
  v %= 100000;
  const thousand = Math.floor(v / 1000);
  v %= 1000;
  const hundred = Math.floor(v / 100);
  v %= 100;

  if (crore) parts.push(`${twoDigits(crore)} Crore`);
  if (lakh) parts.push(`${twoDigits(lakh)} Lakh`);
  if (thousand) parts.push(`${twoDigits(thousand)} Thousand`);
  if (hundred) parts.push(`${ONES[hundred]} Hundred`);
  if (v) parts.push(twoDigits(v));

  return parts.join(" ").replace(/\s+/g, " ").trim();
}

export function formatInr(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return "—";
  return `₹${Math.round(v).toLocaleString("en-IN")}`;
}

/** INR with up to 2 decimal places (Hyper unit price / GST lines). */
export function formatInrDecimal(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return "—";
  if (Math.abs(v - Math.round(v)) < 0.0001) {
    return formatInr(v);
  }
  return `₹${v.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/** Paise integer from API → rupee display (works with encrypted amount fields after decrypt). */
export function formatPaiseAsInr(paise) {
  if (paise == null || paise === "") return "—";
  const n = Number(paise);
  if (!Number.isFinite(n)) return "—";
  return formatInrDecimal(n / 100);
}

/** Total line: ₹10,000 with words underneath-friendly single string. */
export function formatInrWithWords(n) {
  const formatted = formatInr(n);
  const words = amountInWordsInr(n);
  if (!words || words === "Zero") return formatted;
  return `${formatted} (${words})`;
}
